<template>
  <div class="mt20 item-wrapper">
    <div class="delete-icon" @click.stop="deleteItem" style="z-index: 10000000" v-if="deleteShow">
      <img :src="deleteicon" alt="" style="width: 25px">
    </div>

    <Form class="form" ref="furnitureItem" :rules="formRules" :model="formData" :label-width="100" :inline="true">
      <Row :gutter="16">
        <Col :span="10">
          <FormItem label="智能平台位置" prop="areaTypeCode">
            <Select class="select-width" v-model="formData.areaTypeCode">
              <Option value="">请选择</Option>
              <Option v-for="(item,index) in areaTypeEnum" :value="item.value" :key="'area'+index">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="24">
        <Col :span="23">
          <FormItem label="智能家具物品" prop="prodTypeIds">
            <div style="max-width: 100%">
              <CheckboxGroup v-if="prodTypeEnum&&prodTypeEnum.length>0" v-model="formData.prodTypeIds">
                <Checkbox v-for="(item,index) in prodTypeEnum" :label="item.value" 
                :key="'floor'+index" :disabled="!isShow||((item.value==='YG0001'&&(hezuffj||zhengzu)) || ((item.value==='YG0002') && hezuzfj)) || ((item.value==='YG0002' || item.value==='YG0001')&&hezuffj&&hezuzfj) "
                >{{item.text}}</Checkbox>
              </CheckboxGroup>
            </div>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>
<script>
import  deleteicon from '../../../assets/icon/icon_delete@2x.png'
import {  getDeviceType } from "api/smartWorkOrder"
  import {deepClone} from "../../../utils/format";
  export default {
    props:{
      deleteShow:{
        type:Boolean,
        default:false
      },
      itemIndex:{
        type:Number,
        default:0
      },
      formData: {
        type:Object,
        default:null
      },
      zhengzu:{
        type:Boolean,
        default:false
      },
      hezu:{
        type:Boolean,
        default:false
      },
      gongqu:{
        type:Boolean,
        default:false
      },
      hezuzfj:{
        type:Boolean,
        default:false
      },
      hezuffj:{
        type:Boolean,
        default:false
      }
    },
    data() {
      return {
        deleteicon:deleteicon,
        prodTypeEnum:[],
        areaTypeEnum:[],
        formRules: {
          // "areaTypeCode": [{ required: true, type:'string', message:'请选择智能平台位置', trigger: 'change'}],
          prodTypeIds: [{required: true, message: ' ', trigger: 'change', type: 'array'}]
        },
      }
    },
    watch:{
      hezu(){
          if(this.hezu){
           let index = this.formData.prodTypeIds.findIndex(item => {
             return item === 'YG0002'
          })
          if(index>-1){
            this.formData.prodTypeIds.splice(index,1)
          }
        }
        if(this.hezu&&this.zhengzu){
          let index = this.formData.prodTypeIds.findIndex(item => {
             return item === 'YG0001'
          })
          if(index>-1){
            this.formData.prodTypeIds.splice(index,1)
          }
        }
      },
      zhengzu(){
        if(this.hezu&&this.zhengzu){
          let index = this.formData.prodTypeIds.findIndex(item => {
             return item === 'YG0001'
          })
          if(index>-1){
            this.formData.prodTypeIds.splice(index,1)
          }
        }
      }
    },
    computed:{
      isShow(){
        if(this.hezu || this.zhengzu || this.gongqu){
          return true
        } else{
          return false
        }
      }
    },
    methods: {
      deleteItem(){
        this.$emit('deleteItem', this.itemIndex)
      }
    },
    created(){
      getDeviceType().then(res => {
        if(res.data){
          this.areaTypeEnum = res.data.areaType
          this.prodTypeEnum = res.data.prodType
          this.prodTypeEnum.forEach(ele=>{
            ele['dis'] = true
          }) 
        }
      }).catch(error => {
      })
    }
  }
</script>
<style scoped>
  .item-wrapper {
    /*padding-left: 20px;*/
    position: relative;
  }

  .delete-icon {
    /*float: left;*/
    /*display: inline-block;*/
    padding:3px 30px;
    font-size: 14px;
    /*border: 1px solid rgb(220,220,220);*/
    /*border-bottom: none;*/
    /*background-color: rgb(240,240,240);*/
    text-align: right;
    box-sizing: border-box;
    position: absolute;
    right: 30px;
    top: 10px;
  }
  .form {
    border: 1px solid rgb(220, 220, 220);
    overflow: auto;
    padding-top: 24px;
  }

  .input-long {
    width: 200px;
  }

  .select-width {
    width: 100px;
  }

  .input-short {
    width: 100px;
  }

</style>
